module.exports = __webpack_public_path__ + "6cfd7fe17f9fca7e712e2a79ec1d6a7f.png";